import { AccountIcon } from "@fla/components";
import { useLocation } from "react-router-dom";

import Register from ".";

export default function RegisterInFlow() {
  const { pathname } = useLocation();

  return (
    <div className="bg-white max-w-2xl py-5 mx-auto md:rounded-lg md:shadow-md px-5 md:p-10 flex flex-col items-center space-y-5">
      <AccountIcon strokeColor="text-gray-dark" />
      <h2 className="text-center">
        Create An Account To
        <br /> Continue
      </h2>
      <Register as="in-flow" href={pathname} />
    </div>
  );
}
